<div class="qr-popup-surface">
  <h2 mat-dialog-title class="title">
    <span class="title-badge"><i class="material-icons">lock</i></span>
    <span class="title-text">{{description}}</span>
  </h2>
  <mat-dialog-content>
    <div class="dialog-options-container">
      <div class="qr-frame">
        <span class="qr-corner tl"></span>
        <span class="qr-corner tr"></span>
        <span class="qr-corner bl"></span>
        <span class="qr-corner br"></span>
        <app-qr-generator [height]="250" [width]="250" [qrUrl]="qrUrl"></app-qr-generator>
      </div>
      <p class="qr-subtitle"><i class="material-icons">photo_camera</i>Scan with your phone camera to pay securely</p>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end" *ngIf="currentUser.orgSettings.accountType === Constants.CLOVER">
    <div class="button-container">
      <button *ngIf="false" [disabled]="buttonDisabled" mdbBtn color="info" block="true" class="my-4 example-full-width qr-btn qr-btn-secondary" (click)="startOver()">Start Over<i class="material-icons">restart_alt</i></button>
      <button *ngIf="selectedRole === Constants.KIOSK" [disabled]="buttonDisabled" mdbBtn color="success" block="true" class="my-4 example-full-width qr-btn qr-btn-primary" (click)="startNextOrder()">Start Next Order<i class="material-icons">arrow_forward</i></button>
      <button [disabled]="buttonDisabled" mdbBtn color="danger" block="true" class="my-4 example-full-width edit-order-button qr-btn qr-btn-ghost" (click)="closeAndCancelOrder()">Cancel &amp; Return To Cart</button></div>
  </mat-dialog-actions>
  <mat-dialog-actions align="end" *ngIf="currentUser.orgSettings.accountType === Constants.SQUARE">
    <div class="button-container">
      <button *ngIf="selectedRole !== 'Admin' && selectedRole !== 'Manager' && selectedRole !== 'Server'" [disabled]="buttonDisabled" mdbBtn color="danger" block="true" class="my-4 example-full-width qr-btn qr-btn-ghost" (click)="closeAndCancelOrderSquare()">Cancel Order</button>
      <button *ngIf="selectedRole === 'Admin' || selectedRole === 'Manager' || selectedRole === 'Server'" [disabled]="buttonDisabled" mdbBtn color="danger" block="true" class="my-4 example-full-width qr-btn qr-btn-ghost" (click)="closeAndCancelOrderSquare()">Cancel Order</button>
    </div>
  </mat-dialog-actions>
</div>
